import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getArticles,
  getArticleById,
  getArticlesByCategory,
} from "api/articles.api";

export const getArticlesAsync = createAsyncThunk(
  "articles/get-all",
  async () => {
    const articles = await getArticles();
    return articles;
  }
);

export const getArticleByIdAsync = createAsyncThunk(
  "article/get-by-id",
  async (id) => {
    const article = await getArticleById(id);
    const response = await fetch(article.content);
    const text = await response.text();
    return { ...article, content: response.status === 200 ? text : "" };
  }
);

export const getArticlesByCategoryAsync = createAsyncThunk(
  "article/get-by-category",
  async (category) => {
    const articles = await getArticlesByCategory(category);
    return articles;
  }
);
